<template>
    <Loading :loading="loading" class="min-h-screen">
        <div class="min-h-screen w-full bg-[#f1f6fa] px-6 lg:px-20 lg:py-10 flex flex-col gap-6">
            <MarketsHeader v-if="!currentProductGroupLoading" :current-product-group="currentProductGroup" />
            <!--Toggle between to two icons-->
            <div class="bg-white rounded-xl flex flex-row p-2 sm:w-max gap-8 relative" @click="toggleActive = !toggleActive">
                <div class="cursor-pointer flex items-center py-2 pl-2 pr-2 gap-2 rounded-xl relative z-10">
                    <img v-if="currentProductGroup.image" class="w-16 h-16 p-2.5 object-contain" :src="currentProductGroup.image.replace('.png', '-gradient.png')" />
                    <p class="font-bold">{{ $translate(currentProductGroupName).split('/')[0] }}</p>
                </div>

                <div class="cursor-pointer flex items-center py-2 pl-2 pr-2 gap-2 rounded-xl relative z-10">
                    <img v-if="currentProductGroup.image" class="w-16 h-16 p-2.5 object-contain" :src="currentProductGroup.image.replace('.png', '-gradient.png')" />
                    <p class="font-bold">{{ $translate(currentProductGroupName).split('/')[1] }}</p>
                </div>

                <div class="bg-dashboard-primary w-1/2 h-20 rounded-xl transform duration-300 ease-in-out absolute z-0" :class="{ 'translate-x-[92%]': toggleActive }"></div>
            </div>
            <div class="flex flex-col lg:flex-row gap-4">
                <TradingviewChart
                    v-if="productGroupId"
                    :product-id="productGroupId"
                    :toggle-tab="toggleActive"
                    layout="single"
                    class="w-full lg:w-2/3 bg-white rounded-xl p-10 xl:px-4 h-fit shadow-md"
                />
                <ContentstreamsListV2
                    v-if="currentProductGroup?.products?.data"
                    class="w-full lg:w-1/3 shadow-md"
                    :show-dropdown="false"
                    :page-size="40"
                    :product-id="currentProductGroup?.products?.data[0].id"
                    :init-filter="['short', 'webinar', 'wmu', 'dsu', 'dmu']"
                ></ContentstreamsListV2>
            </div>
            <div class="flex flex-col lg:flex-row gap-4">
                <Sheet v-if="currentProductGroup && productIds.length > 0" class="w-full fit shadow-md">
                    <MarketsSocials :current-product-group="currentProductGroup" :product-ids="productIds"
                /></Sheet>
            </div>
        </div>
    </Loading>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '../../miscellaneous/Loading.vue';
import Sheet from '../../Sheet.vue';
import ContentstreamsListV2 from '../ContentstreamsListV2.vue';
import MarketsHeader from '../MarketsHeader.vue';
import MarketsSocials from '../MarketsSocials.vue';
import TradingviewChart from '../TradingviewChart.vue';

const store = useStore();
const route = useRoute();

const productGroupId = route.params.id;
const contentstreams = ref([]);
let currentProductGroupLoading = true;
const currentProductGroup = ref({});
const currentProductGroupName = ref('');
const currentProductGroupDescription = ref('');
const currentProducts = ref({});
const toggleActive = ref(false);
const loading = ref(true);
const productIds = ref([]);
const contentstreamIsLoaded = computed(() => store.getters['contentstreams/all'].dashboard);

onMounted(() => {
    fetchProductGroup(productGroupId);
});

/**
 * Get content streams by product id
 * @param ids of products in current Productgroup string
 */
const fetchAndProcessContentStreams = async (productIds) => {
    const get = await store.getters['contentstreams/all'];
    contentstreams.value = get?.dashboard?.data.filter((item) => productIds.includes(item.product_id)).sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

    loading.value = false;
};

const fetchProductGroup = (id) => {
    store.dispatch('product_group/show', id).then(() => {
        currentProductGroup.value = store.getters['product_group/get'];

        currentProductGroupName.value = currentProductGroup.value?.name;
        currentProductGroupDescription.value = currentProductGroup?.value?.description;
        currentProducts.value = currentProductGroup.value?.products?.data;

        productIds.value = currentProducts.value.map((product) => product.id);

        currentProductGroupLoading = false;
    });
};

const resetProductGroupData = () => {
    contentstreams.value = [];
    currentProductGroupLoading.value = true;
    currentProductGroup.value = {};
    currentProductGroupName.value = '';
    currentProductGroupDescription.value = '';
    currentProducts.value = {};
    loading.value = true;
    productIds.value = [];
};

watch(
    () => route.params.id,
    (newId, oldId) => {
        if (newId !== oldId && route.name.includes('markets-')) {
            resetProductGroupData();
        }
    }
);

watch([contentstreamIsLoaded, productIds], ([isLoaded, ids]) => {
    if (isLoaded && ids.length) {
        fetchAndProcessContentStreams(ids);
    }
});
</script>
